import { NonNullScore, Score } from "@examspark/types";

export * from "./associate";
export * from "./cartesian-graph";
export * from "./cartesian-inequality";
export * from "./choice";
export * from "./fraction-model";
export * from "./graphic-associate";
export * from "./graphic-gap-match";
export * from "./graphic-hotspot";
export * from "./graphic-order";
export * from "./graphic-position-object";
export * from "./graphic-select-point";
export * from "./graphing/common";
export * from "./match";
export * from "./matchTable";
export * from "./order";
export * from "./text-extended";
export * from "./text-gap-match";
export * from "./text-inline";
export * from "./text-selectable";

export const getNewScore = (): NonNullScore => {
  return {
    min: 0,
    max: 0,
    actual: 0,
    isScorable: true,
  };
};

export const getNewScoreNullable = (): Score => {
  return {
    min: 0,
    max: 0,
    isScorable: true,
  };
};
